import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplicationMethodMatchingService {
  constructor(private http: HttpClient) {}
  
  getApplicationMethodMatchings(pDisciplinePk: number = -1): Observable<any[]> {
    return this.http
      .get(`${environment.BAMS_Api_URL}api/applicationMethodMatchings/${pDisciplinePk}`)
      .pipe(map((data: any) => data.Value));
  }
  
  saveData(pData: any) {
    const body = JSON.stringify(pData);
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const query = `${environment.BAMS_Api_URL}api/applicationMethodMatchings`;
    return this.http
      .put(query, body, { headers })
      .pipe(map((data: any) => data.Value));
  }
}
